import { makeNoteMockData } from '../../modules/noteMockDataFactory'
import type { IOpportunityNote } from '~/types/note/models'

export const {
  getNoteListData: getOpportunityNoteListData,
  getNoteDataById: getOpportunityNoteDataById,
  getNoteListDataByParentId: getOpportunityNoteListDataByOpportunityId,
} = makeNoteMockData<IOpportunityNote>({
  entityName: 'opportunity',
  storageKeyPrefix: 'opportunity',
})
